import axios from 'axios'

const fileDownload = require('js-file-download')

const download = (file) => {
  const { fileFileUrl, fileFileName } = file
  axios.get(fileFileUrl, {
    responseType: 'blob',
  }).then((res) => {
    fileDownload(res.data, fileFileName)
  })
}
export { download }
